import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRightIcon } from 'lucide-react';
interface BuyButtonProps {
  children: React.ReactNode;
  className?: string;
  size?: 'md' | 'lg';
}
export function BuyButton({
  children,
  className = '',
  size = 'lg'
}: BuyButtonProps) {
  const sizing = size === 'lg' ? 'px-8 py-4 text-base sm:text-lg' : 'px-6 py-3 text-sm sm:text-base';
  return <motion.a href="https://yoga-360.impultienda.ar/checkout" whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} className={`group inline-flex items-center justify-center gap-2 rounded-full bg-clay font-semibold text-cream shadow-lg shadow-clay/25 transition-colors hover:bg-[#bf6f87] ${sizing} ${className}`} data-id="element-269" data-mp="z5km7in5yvog">
      <span data-id="element-270" data-mp="1d657qmkgr5ln">{children}</span>
      <ArrowRightIcon className="h-5 w-5 transition-transform group-hover:translate-x-1" data-id="element-271" data-mp="2kie1ysorqof1" />
    </motion.a>;
}